if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');
      this.mainForm = this.productForm ? this.productForm.querySelector('.js-product-form') : null;
      this.stickyAddBtn = this.querySelector('[data-sticky-add]');
      this.stickyBuyBtn = this.querySelector('[data-sticky-buy]');

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }

      if (this.stickyAddBtn && this.stickyBuyBtn && this.mainForm) {
        this.bindNeonMobileActions();
      }
    }

    // eslint-disable-next-line class-methods-use-this
    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    bindEvents() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.productForm && !theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.boundingClientRect.bottom > 0);
          } else if (entry.target === this.productInfo && theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
          }
        });
      });

      if (this.productForm) observer.observe(this.productForm);
      if (this.productInfo) observer.observe(this.productInfo);

      window.addEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    bindNeonMobileActions() {
      this.stickyAddBtn.addEventListener('click', () => {
        const mainAddBtn = this.mainForm.querySelector('[name="add"]');
        if (mainAddBtn && !mainAddBtn.disabled) mainAddBtn.click();
      });

      this.stickyBuyBtn.addEventListener('click', this.handleBuyNow.bind(this));

      this.productSection.addEventListener('on:variant:change', (evt) => {
        const available = Boolean(evt.detail.variant && evt.detail.variant.available);
        this.stickyAddBtn.disabled = !available;
        this.stickyBuyBtn.disabled = !available;

        const mainPrice = this.productSection.querySelector('.product-info__price > .price');
        const stickyPrice = this.querySelector('.sticky-atc-panel__mobile-price > .price');
        if (mainPrice && stickyPrice) stickyPrice.innerHTML = mainPrice.innerHTML;
      });
    }

    async handleBuyNow() {
      const variantInput = this.mainForm.querySelector('[name="id"]');
      if (!variantInput || !variantInput.value || this.stickyBuyBtn.disabled) return;

      this.stickyBuyBtn.disabled = true;

      const formData = new FormData();
      formData.append('id', variantInput.value);
      formData.append('quantity', '1');

      try {
        const response = await fetch(theme.routes.cartAdd, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: formData
        });

        if (!response.ok) throw new Error(response.status);
        window.location.href = '/checkout';
      } catch (error) {
        this.stickyBuyBtn.disabled = false;
        const mainAddBtn = this.mainForm.querySelector('[name="add"]');
        if (mainAddBtn && !mainAddBtn.disabled) mainAddBtn.click();
      }
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
